




export default function Unauth() {
    return(
        <div style={{"display":"flex", "flexDirection":"column", "alignItems":"center", "justifyContent":"center", "height":"80vh"}}>
        <h1>Unauthorized Access</h1>
        <p>You shouldn't be here buddy.</p>
        </div>
    )
}